<template>
  <b-card>
    <title-name />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import TitleName from '@/views/Admin/Product_groups/elements/Title.vue'

export default {
  name: 'ProductGroupForm',
  components: {
    BCard,
    TitleName,
  },
}
</script>
